// La cara de la empresa antes de entrar: logo (o su inicial) y nombre sobre el color de la marca, y abajo la tarjeta
// con lo que corresponde. En las pantallas con formulario (entrar, crear la cuenta, la contraseña, los datos del
// negocio) la cabecera va compacta, en un renglón, para que el formulario y los botones entren en la primera pantalla
// del celular; la grande queda para los avisos de pantalla entera (tienda cerrada, sin acceso).
import { cx, Icono } from '@reparto/ui';
import type { ReactNode } from 'react';
import type { Marca } from '../datos/tipos';

export function Logo({ marca, tamano = 72 }: { marca: Pick<Marca, 'nombre' | 'logo_url'> | null; tamano?: number }) {
  if (marca?.logo_url)
    return (
      <img
        src={marca.logo_url}
        alt=""
        width={tamano}
        height={tamano}
        className="rounded-2xl bg-[#fff] object-contain p-1.5 shadow-sm ring-1 ring-stone-200"
        style={{ width: tamano, height: tamano }}
      />
    );
  return (
    <span
      aria-hidden="true"
      className="grid place-items-center rounded-2xl bg-white text-primary-700 shadow-sm ring-1 ring-stone-200"
      style={{ width: tamano, height: tamano }}
    >
      {marca ? (
        <span className="font-bold" style={{ fontSize: tamano * 0.46 }}>
          {marca.nombre
            .replace(/^(distribuidora|comercial|importadora)\s+/i, '')
            .charAt(0)
            .toUpperCase()}
        </span>
      ) : (
        <Icono nombre="storefront" tamano={tamano * 0.5} />
      )}
    </span>
  );
}

export function Bienvenida({
  marca,
  lema = 'Hacé tus pedidos desde el celular',
  grande = false,
  children,
}: {
  marca: Pick<Marca, 'nombre' | 'logo_url'> | null;
  lema?: string;
  /** Cabecera alta, con el logo grande: para los avisos de pantalla entera. */
  grande?: boolean;
  children: ReactNode;
}) {
  const nombre = marca?.nombre ?? 'Tienda de pedidos';
  return (
    <div className="flex min-h-dvh flex-col bg-primary-600">
      <div className="seguro-arriba text-sobre-marca">
        {grande ? (
          <div className="mx-auto max-w-md px-6 pt-12 pb-10">
            <Logo marca={marca} />
            <h1 className="mt-5 text-[28px] leading-tight font-bold">{nombre}</h1>
            <p className="mt-1 text-lg opacity-90">{lema}</p>
          </div>
        ) : (
          <div className="mx-auto flex max-w-md items-center gap-3 px-6 pt-5 pb-7">
            <Logo marca={marca} tamano={48} />
            <div className="min-w-0">
              <h1 className="truncate text-xl leading-tight font-bold">{nombre}</h1>
              <p className="truncate text-[15px] opacity-90">{lema}</p>
            </div>
          </div>
        )}
      </div>
      <div className="seguro-abajo -mt-2 flex-1 rounded-t-4xl bg-fondo text-stone-900">
        <div className={cx('mx-auto max-w-md px-6 pb-10', grande ? 'pt-8' : 'pt-6')}>{children}</div>
      </div>
    </div>
  );
}
